import React from "react";

function QuickInsightLending() {
  return (
    <div className="about-area pt-5 pb-5 mt-n5 position-relative z-2">
      <div className="container">
        <div
          className="row align-items-center justify-content-center text-center p-5 mx-0"
          style={{
            background: "rgba(255, 255, 255, 0.03)",
            backdropFilter: "blur(15px)",
            WebkitBackdropFilter: "blur(15px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRadius: "30px",
            color: "white",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
            position: "relative",
            overflow: "hidden"
          }}
        >
          {/* Subtle glow effect */}
          <div className="position-absolute w-100 h-100 top-0 start-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(33, 150, 243, 0.1), transparent)", zIndex: -1 }}></div>
          
          <div className="col-lg-10">
            <span className="text-secondary fw-bold text-uppercase mb-2 d-block" style={{ fontSize: "14px", letterSpacing: "2px" }}>Industry Analysis</span>
            <h2 className="title mb-4" style={{ fontWeight: "800", fontSize: "36px" }}>
              Quick Insight For DeFi Lending Industry
            </h2>
            <div 
              style={{ 
                height: "4px", 
                width: "60px", 
                background: "#2196F3", 
                margin: "0 auto 30px auto",
                borderRadius: "2px" 
              }} 
            ></div>
            <p style={{ opacity: "0.8", fontSize: "18px", lineHeight: "1.8", fontWeight: "400" }}>
              DeFi lending and borrowing protocols have transformed traditional financial systems by 
              enabling decentralized, permissionless, and highly secure asset exchanges. By eliminating 
              centralized intermediaries, these platforms provide unmatched transparency and 
              geometric APY returns, fueling the next wave of global financial innovation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuickInsightLending;
